var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.user)?_c('v-avatar',{style:({'background-color': _vm.backgroundColor}),attrs:{"size":128}},[_c('strong',{staticClass:"initials",style:({'color': _vm.fontColor,
                  'font-size': _vm.fontSize})},[_vm._v(" "+_vm._s(((_vm.user.name && _vm.user.lastName) ? _vm.user.name[0] + _vm.user.lastName[0] : '') || '?')+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }